import { Injectable } from '@angular/core';
import { ApiClass } from "@data/class/api-class";
import { IActiveList } from "@modules/private/active/data/interfaces/iactive.interface";
import { IResponseArray } from "@data/interfaces/iresponseArray.interface";
import { environment } from "@env/environment";
import { catchError, map, Observable, of } from "rxjs";
import { FilterOptions } from '@shared/interfaces/filterOptions.interface';

@Injectable({
  providedIn: 'root'
})
export class ApiActiveService extends ApiClass {
  constructor() {
    super()
    this.path = 'assets'
  }

  getAll(page = 1, limit = 10, filters = {}) {
    this.path = 'assets'
    const response: IActiveList = { error: true, msg: '', data: [], total: 0, status: 200, page: 1, itemsByPage: 10, totalItems: 0 }

    const populate = [{ path: 'client', select: 'name' }]
    return this.http.post<IResponseArray>(environment.apiUrl + this.path, { page, limit, filters, populate }).pipe(
      map((r) => r as IActiveList),
      catchError((e) => of(response))
    )
  }

  fetchProviders(filterOptions: FilterOptions): Observable<{ label: string, value: string }[]> {
    this.path = 'providers'

    return this.postCollection(filterOptions).pipe(
      map((response) => {
        if (!response.error && Array.isArray(response.data.data)) {
          return response.data.data.map((provider: { _id: string; fullName: string }) => ({
            label: provider.fullName, value: provider._id
          }))
        } else {
          console.error('Error al obtener los proveedores', response.msg)
          return []
        }
      }),
      catchError((e) => {
        console.error('Error al obtener los proveedores', e)
        return of([])
      })
    )
  }

  create(data: any) {
    data.status = 'Activo'
    
    return this.postCollection(data, 'create').pipe(map((r) => r as { error: boolean, msg: string, data: any })).pipe(
      map((r) => r as { error: boolean, msg: string, data: any })
    )
  }

  getById(id: string) {
    return this.getCollection(id).pipe(map((r) => r as { error: boolean, msg: string, data: any })).pipe(
      map((r) => r as { error: boolean, msg: string, data: any })
    )
  }

  update(id: string, data: any) {
    return this.putCollection(data, undefined, 'assets/' + id).pipe(map((r) => r as { error: boolean, msg: string, data: any })).pipe(
      map((r) => r as { error: boolean, msg: string, data: any })
    )
  }

  /**
   * Descargar documento por URL
   */
  downloadDocumentByUrl(fileUrl: string): Observable<Blob> {
    const encodedUrl = encodeURIComponent(fileUrl);
    return this.http.get(`${environment.apiUrl}documents/download?fileUrl=${encodedUrl}`, {
      responseType: 'blob'
    }).pipe(
      catchError((error) => {
        console.error('Error al descargar archivo:', error);
        throw error;
      })
    );
  }
}
